/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeDownFilled = createReactComponent("filled", "arrow-badge-down-filled", "IconArrowBadgeDownFilled", [["path", { "d": "M16.375 6.22l-4.375 3.498l-4.375 -3.5a1 1 0 0 0 -1.625 .782v6a1 1 0 0 0 .375 .78l5 4a1 1 0 0 0 1.25 0l5 -4a1 1 0 0 0 .375 -.78v-6a1 1 0 0 0 -1.625 -.78z", "key": "svg-0" }]]);

export { IconArrowBadgeDownFilled as default };
//# sourceMappingURL=IconArrowBadgeDownFilled.mjs.map
